const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
const MAX_EMAIL_LENGTH = 254;

export const isValidEmail = (value) => validateEmail(value).valid;

export const validateEmail = (value) => {
  const email = String(value || "").trim();

  if (!email) {
    return { valid: false, error: "Email is required" };
  }

  if (email.length > MAX_EMAIL_LENGTH) {
    return { valid: false, error: "Email must be 254 characters or fewer" };
  }

  if (/\s/.test(email)) {
    return { valid: false, error: "Email cannot contain spaces" };
  }

  if (email.includes("..")) {
    return { valid: false, error: "Enter a valid email address" };
  }

  const atIndex = email.indexOf("@");
  if (atIndex <= 0 || atIndex !== email.lastIndexOf("@")) {
    return { valid: false, error: "Enter a valid email address" };
  }

  const local = email.slice(0, atIndex);
  const domain = email.slice(atIndex + 1);

  if (local.startsWith(".") || local.endsWith(".")) {
    return { valid: false, error: "Enter a valid email address" };
  }

  if (!domain || domain.startsWith(".") || domain.endsWith(".")) {
    return { valid: false, error: "Enter a valid email address" };
  }

  if (!domain.includes(".")) {
    return { valid: false, error: "Enter a valid email address" };
  }

  const tld = domain.split(".").pop();
  if (!tld || tld.length < 2) {
    return { valid: false, error: "Enter a valid email address" };
  }

  if (!EMAIL_REGEX.test(email)) {
    return { valid: false, error: "Enter a valid email address" };
  }

  return { valid: true, error: "" };
};
